import { render, staticRenderFns } from "./historico-servidores.vue?vue&type=template&id=6abc3956&scoped=true&"
import script from "./historico-servidores.vue?vue&type=script&lang=js&"
export * from "./historico-servidores.vue?vue&type=script&lang=js&"
import style0 from "./historico-servidores.vue?vue&type=style&index=0&id=6abc3956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc3956",
  null
  
)

export default component.exports